export const problemsForm: any = {
    problem:"",
    createdAt:""
  };
  